<template>
    <div id="impressum" class="impressum">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="impressum-link">
                        <a href="#" class="impressum-link" data-toggle="modal" data-target="#impressum-modal">Impressum</a>
                    </div>
                </div>
            </div>
        </div>

        <div id="impressum-modal" class="modal fade" tabindex="-1"  role="dialog">
            <div class="modal-dialog" role="document">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="container">
                            <div class="col-md-10 col-md-offset-1">
                                <h3>Impressum</h3><br>
                                <div v-html="impressumText"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Schließen</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    let ax = axios.create({
        baseURL: 'http://hessestudios.de/wp/wp-json/wp/v2/pages/77'
    });
    export default {
        name: 'Impressum',
        data(){
            return {
                impressumText : "",
            };
        },
        mounted(){
            ax.get().then(response => {
                this.impressumText = response.data.content.rendered;
            });
        }
    }
</script>
